import styled from "styled-components";
import { PhotoProfile } from "../ProfilePicture/style";

export const AddPhotoInput = styled.input`
display: none;
`;

export const StyledPhotoProfile = styled(PhotoProfile)`
width: 100px;
height: 100px;
margin-right: 50px;
border: solid 2px; 
`;
